import LancamentoMovimentacaoBaseModel from "./lancamentoMovimentacaoBaseModel";

export default class ContaPagarPagamentoModel extends LancamentoMovimentacaoBaseModel {}
